import React from 'react';

import withAppLayout from '../../hoc/withAppLayout';
import ThemeContainer from '../../containers/ThemeContainer/V2/ThemeContainerV2';

const Portfolio = ({roleType}) => <ThemeContainer roleType={roleType} />;

export default withAppLayout(Portfolio);
